const isDataObject = value => value !== null && typeof value === 'object' && !(value instanceof Error);

const isEmptyDataObject = value => isDataObject(value) && Object.keys(value).length === 0;

const toLoggable = value => (value instanceof Error
    ? { name: value.name, message: value.message, stack: value.stack }
    : value);

const toExtraValue = (arg) => {
    if (!isDataObject(arg)) {
        return toLoggable(arg);
    }

    const { fingerprint, ...argWithoutFingerprint } = arg;

    return Object.keys(argWithoutFingerprint).reduce((result, key) => ({
        ...result,
        [key]: toLoggable(argWithoutFingerprint[key]),
    }), {});
};

const toRavenOptions = (level, args, loggerName) => {
    const meaningfulArgs = args.filter(arg => !isEmptyDataObject(arg));
    const dataObjects = meaningfulArgs.filter(isDataObject);
    const options = {
        level,
        extra: meaningfulArgs.length > 0
            ? meaningfulArgs.reduce((extra, arg, index) => ({ ...extra, [index]: toExtraValue(arg) }), {})
            : null,
        logger: loggerName,
    };

    if (dataObjects.length === 0) {
        return options;
    }

    return { ...options, fingerprint: dataObjects[dataObjects.length - 1].fingerprint };
};

const reportMessage = (provider, level, args) => {
    if (args.length === 0) {
        throw new Error('At least one argument must be provided');
    }

    const [message, ...restArgs] = args;
    provider.raven.captureMessage(message, toRavenOptions(level, restArgs, provider.loggerName));
};

export default class RavenProvider {
    constructor(raven, loggerName = null) {
        this.raven = raven;
        this.loggerName = loggerName;
    }

    getName() {
        return 'sentry';
    }

    log(...args) {
        reportMessage(this, 'info', args);
    }

    debug(...args) {
        reportMessage(this, 'info', args);
    }

    info(...args) {
        reportMessage(this, 'info', args);
    }

    warn(...args) {
        reportMessage(this, 'warning', args);
    }

    error(...args) {
        reportMessage(this, 'error', args);
    }

    captureException(exception, ...args) {
        this.raven.captureException(exception, toRavenOptions('error', args, this.loggerName));
    }

    captureBreadcrumb(message, ...args) {
        const { logger, extra, ...restData } = toRavenOptions('info', args, this.loggerName);

        this.raven.captureBreadcrumb({
            message,
            category: logger,
            data: extra,
            ...restData,
        });
    }
}
